"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultLabelName = void 0;
exports.defaultLabelName = '';
